module.exports = __webpack_public_path__ + "static/media/reedem-point-icon.6e3867e9.svg";